import SchoolItem from './src/school-item/SchoolItem';

import SchoolPicture from './src/school-item/SchoolPicture';
import SchoolNameAddress from './src/school-item/SchoolNameAddress';
import SchoolAction from './src/school-item/SchoolAction';

export { SchoolPicture, SchoolNameAddress, SchoolAction };
export default SchoolItem;
